import { Button, DialogFooter, useDialogAction } from '@gitbook/spine-react';

import { useCheckoutSite, useSiteContext } from '../../../../../../state';
import { useTogglePublishedModal } from '../../PublishSuccessDialog';

export function PublishFooter() {
    const { organizationId, site } = useSiteContext();
    const checkout = useCheckoutSite(organizationId, site);

    const togglePublishedModal = useTogglePublishedModal();
    const [, startDialogAction] = useDialogAction();

    async function checkoutAndPublish() {
        await startDialogAction(async ({ close }) => {
            const published = await checkout.onPress();
            togglePublishedModal(published);
            await close();
        });
    }

    return (
        <DialogFooter>
            <Button
                {...checkout.buttonProps}
                onPress={async () => {
                    await checkoutAndPublish();
                }}
            />
        </DialogFooter>
    );
}
